import { Injectable } from '@angular/core';

interface iUndoRedoStack{
    past: Array<any>;
    future: Array<any>;
    present: any
};
@Injectable()
export class UndoRedoStack{

    private jsonEqual(a,b) {
        let aCopy = Object.assign({}, a);
        let bCopy = Object.assign({}, b);
        delete aCopy.date;
        delete bCopy.date;
        return JSON.stringify(aCopy) === JSON.stringify(bCopy);
    }

    public init() : iUndoRedoStack {
        return {
            past: [],
            present: null,
            future: []
        };
    }


    public pop(stack: iUndoRedoStack, url: string){
        const stackCopy = Object.assign({}, stack);
        if (stackCopy.future.length < 1){
            return this.undo(stackCopy);
        }
        const previous = stackCopy.past[stackCopy.past.length - 1];
        if (previous.url == url ){
            return this.undo(stack);
        }
        else{
            const next = stackCopy.future[0];
            if (next.url == url){
                return this.redo(stack);
            }
            else{
                return stack;
            }
        }
    }

    public undo(stack: iUndoRedoStack){
        const stackCopy = Object.assign({}, stack);
        const previous = stackCopy.past[stackCopy.past.length - 1];
        const newPast = stackCopy.past.slice(0, stackCopy.past.length - 1);
        const newFuture  = [ stackCopy.present, ...stackCopy.future ]
        return {
            past: newPast,
            present: previous,
            future: newFuture
        };
    }

    public redo(stack: iUndoRedoStack){
        const stackCopy = Object.assign({}, stack);
        const next = stackCopy.future[0];
        const newFuture = stackCopy.future.slice(1);
        return {
            past: [ ...stackCopy.past, stackCopy.present ],
            present: next,
            future: newFuture
        };
    }

    public add(stack: iUndoRedoStack, newState){
        const stackCopy = Object.assign({}, stack);
        if (this.jsonEqual(stackCopy.present, newState)) {
            return stack;
        }
        return {
            past: (stackCopy.present) ? [ ...stackCopy.past, stackCopy.present ] : [ ...stackCopy.past],
            present: newState,
            future: []
        }
    }


}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/util/undo.redo.stack.ts